






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxLookup } from 'devextreme-vue';
import notificationService from '@/services/notificationService';
import cPopup from '@/components/default/Popup.vue';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxItem,
  DxLabel,
} from 'devextreme-vue/form';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import projectsRepository from '@/services/projectsRepository';

@Component({
  components: {
    DxPopup,
    DxLookup,
    DxSimpleItem,
    DxGroupItem,
    DxForm,
    DxLabel,
    DxItem,
    DxToolbarItem,
    DxRequiredRule,
    cPopup,
  },
})
export default class ProjectDialog extends Vue {
  public saving: boolean = false;
  public loading: boolean = false;
  public progressStatementGenerationModel: any = {
    projectId: null,
    measurementNames: null,
    progressStatementId: null,
  };

  @Prop({required: true, default: false})
  public show?: boolean;

  @Prop({required: true, default: []})
  public progressStatements?: any[];

  @Prop({required: true, default: []})
  public measurements?: any[];

  public hideDialog() {
    this.$emit('hide');
  }

  get form() {
    const form: any = this.$refs.progressStatementGenerationForm;
    return form.instance;
  }

  get progressStatementsOptions() {
    const self = this;
    return {
      dataSource: self.progressStatements,
      valueExpr: 'id',
      displayExpr: 'documentNumber',
      searchEnabled: true,
      showClearButton: true,
      showCancelButton: true,
    };
  }

  get measurementsOptions() {
    const self = this;
    return {
      dataSource: self.measurements,
      valueExpr: 'name',
      displayExpr: 'name',
    };
  }

  public async save() {
    try {
      const validationResult = this.form.validate();
      if (validationResult.isValid) {
        this.saving = true;
        await projectsRepository.generateProgressStatement(this.progressStatementGenerationModel);
        notificationService.saved();
        this.$emit('saved');
        this.hideDialog();
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }
}
